import { render, staticRenderFns } from "./QLFallRadarlist.vue?vue&type=template&id=edf65be8&scoped=true"
import script from "./QLFallRadarlist.vue?vue&type=script&lang=js"
export * from "./QLFallRadarlist.vue?vue&type=script&lang=js"
import style0 from "./QLFallRadarlist.vue?vue&type=style&index=0&id=edf65be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf65be8",
  null
  
)

export default component.exports